module.exports = __webpack_public_path__ + "static/img/11.d6bb5b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/sp/11.png
// module id = z11L
// module chunks = 0